import React from "react";
import { LatLngBoundsExpression } from "leaflet";

import { DISPATCH_AGENCY_ID } from "../redux/actionTypes";
import { useAppDispatch } from "../redux/hooks";

export const AgencyContext = React.createContext<AgencyContextType | null>(null);

export const AgencyProvider: React.FC<{
  url: string;
  agencyId: string;
  agencyName: string;
  initialMapRange: LatLngBoundsExpression;
  initialMapCenter: LanLngPoint;
  children: React.ReactNode;
  lang: string;
  timeZone: string;
  timeZoneOffsetMinutes: number;
  speedUnit: string;
}> = ({
  url,
  agencyId,
  agencyName,
  initialMapRange,
  initialMapCenter,
  children,
  lang,
  timeZone,
  timeZoneOffsetMinutes,
  speedUnit,
}): JSX.Element => {
  const dispatch: Dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch({ type: DISPATCH_AGENCY_ID, payload: { agencyIdFromContext: agencyId } });
  }, [agencyId, dispatch]);

  // console.log(`AgencyId: ${agencyId} was dispatched`);
  const contextValue = {
    url,
    agencyId,
    agencyName,
    initialMapRange,
    initialMapCenter,
    lang,
    timeZone,
    timeZoneOffsetMinutes,
    speedUnit,
  } as AgencyContextType;

  return <AgencyContext.Provider value={contextValue}>{children}</AgencyContext.Provider>;
};
